import { Button } from '@material-ui/core';
import * as React from 'react';

import { logger } from '../common/logger';

interface AppErrorBoundaryProps {
    children: React.ReactNode;
}

interface AppErrorBoundaryState {
    error: Error | null;
}

export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
        return { error };
    }

    constructor(props: AppErrorBoundaryProps) {
        super(props);
        this.state = { error: null };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        logger.error(error, { componentStack: errorInfo.componentStack });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.assign('/');
    };

    render() {
        const { error } = this.state;
        if (!error) {
            return this.props.children;
        }
        const message = (
            <p>
                <strong>Error:</strong> {error.message}
            </p>
        );
        return (
            <div style={{ padding: '40px', margin: '0 auto', maxWidth: '480px' }}>
                <h3>Something went wrong</h3>
                {message}
                <Button onClick={this.handleReload} variant="outlined" style={{ marginRight: '8px' }}>
                    Reload
                </Button>
                <Button onClick={this.handleGoHome} variant="outlined" style={{ marginRight: '8px' }}>
                    Back to Home
                </Button>
            </div>
        );
    }
}
